import { config } from "../constants";

interface TenantBranding {
  logo_url?: string | null;
}

export function companyLogoUrl(tenant?: TenantBranding | null): string | null {
  const logo = tenant?.logo_url;
  if (!logo) return null;
  if (/^(data:|https?:\/\/)/i.test(logo)) return logo;

  const apiOrigin = config.url.API_URL.replace(/\/api\/?$/, "");
  return `${apiOrigin}${logo.startsWith("/") ? "" : "/"}${logo}`;
}
